import apiClient from './apiClient';

export interface QueryParams {
  codeFrom?: string;
  codeTo?: string;
}

export interface ProcessingFeeRow {
  code: string;
  memo1: string;
  memo2: string;
}

export interface QueryResponse {
  data: ProcessingFeeRow[];
  count: number;
  message?: string;
}

export const pw1312Api = {
  async query(params: QueryParams): Promise<QueryResponse> {
    const res = await apiClient.post('/api/pw1312/query', params);
    return res.data;
  },
};
